import React from "react";
import { Link } from "react-router-dom";
import { StyledAnchor } from "./_.styled";
import { logTopicHeaderLinkClicked } from "../../util/analytics";

const constructLink = (link, isLastLink, telemetryData) => {
  return (
    <>
      <StyledAnchor
        linkComponent={Link}
        href={link.slug.metadata.slug}
        onClick={() => {
          logTopicHeaderLinkClicked(telemetryData);
        }}
        data-testid="cross-content-reference-link-anchor"
      >
        {link.slug.metadata.prettyPubtype}
      </StyledAnchor>
      {isLastLink ? <></> : <span data-testid="multi-link-separator">,</span>}{" "}
    </>
  );
};

const CrossContentReferenceLinkContainer = ({ links, telemetryData }) => {
  return (
    <div data-testid="cross-content-reference-link-container">
      See related{" "}
      {links.map((link, idx) =>
        constructLink(link, links.length - 1 === idx, telemetryData)
      )}
    </div>
  );
};

CrossContentReferenceLinkContainer.displayName =
  "CrossContentReferenceLinkContainer";
export default CrossContentReferenceLinkContainer;
